import React from "react";
import { Container, Box, Paper, Typography, Table, TableBody, TableCell, TableRow, Card, CardContent, Link, Divider } from "@mui/material";
import { styled } from "@mui/material/styles";
import companyProfile from '../../../Assets/adminBannerImage.webp'
import companyLogo from '../../../Assets/WeConnectLogo.png'

const ProfileContainer = styled(Box)(({ theme }) => ({
  backgroundColor: "#f5f5f5",
  minHeight: "100vh",
  padding: theme.spacing(2),
}));

const ProfileCover = styled("img")({
  width: "100%",
  height: "400px",
});

const ProfileImage = styled("img")({
  maxWidth: "150px",
  height: "auto",
  borderRadius: "8px",
});

const ResponsiveBox = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(2),
  [theme.breakpoints.up("md")]: {
    flexDirection: "row",
  },
}));


const CompanyAlumniPara = [
  { content: "Cygnusa has to its credit more than 23000 Alumni since its inception in 1986, working with the industry in key decision making positions and who have been instrumental in shaping the future of fashion business as change agents in India and abroad. They are working at various levels in more than 2000 organizations across the world as Brand Managers, Quality Controllers, Designers, Fashion Coordinators, Merchandisers, Production Managers, and Marketing Heads, etc in leading national and international organisations. Several Cygnusa alumni have become entrepreneurs and successful brands themselves." },
  { content: "The Cygnusa alumni have presented their work on the ramps of Milan, Paris, New York and other fashion centres. They are also active in the fields of media and films. Celebrities and fashion icons across the globe attest to the designers' success in styling and dressing them. Alumni are also active in taking their knowledge to the grass root levels, working with NGOs across India to connect the craftsperson with modern technology, design and markets." },
]

const Home = ({ dynamicLogo, dynamiBanner }) => {
  return (
    <ProfileContainer p={{ xs: 0 }} mb={2} >
      <Box data-aos="zoom-in" data-aos-duration="1000"
        sx={{
          position: 'relative',
        }}
      >
        <Container maxWidth="lg" >
          <Paper elevation={3}>
            <ProfileCover src={dynamiBanner} alt="Profile Cover" />
            <Box display="flex" alignItems="center" p={2}>
              <ProfileImage src={dynamicLogo} alt="Logo" />
            </Box>
          </Paper>
          <Box data-aos="zoom-in" data-aos-duration="1000"
            sx={{
              position: 'relative',
            }}
          >
            <ResponsiveBox mt={2}>
              <Paper elevation={3} sx={{ p: 3, flex: 1 }}>
                <Typography variant="h6" gutterBottom>About</Typography>
                <Divider />
                <Typography variant="body1" mt={1}>
                  Set up in 1986, Cygnusa is the pioneering institute of fashion education in the country and has been in the vanguard of providing professional human resource to the textile and apparel industry. It was made a statutory institute in 2006 by an Act of the Indian Parliament with the President of India as ‘Visitor’ and has full fledged campuses all across the country. Over the years Cygnusa has also been working as a knowledge service provider to the Union and State governments in the area of design development and positioning of handlooms and handicrafts.
                </Typography>
              </Paper>


            </ResponsiveBox>
          </Box>

          <Box data-aos="zoom-in" data-aos-duration="1000"
            sx={{
              position: 'relative',
            }}
          >
            <ResponsiveBox mt={2}>
              <Paper elevation={3} sx={{ p: 3, flex: 1 }}>
                <Typography variant="h6" gutterBottom mt={1}>Cygnusa Alumni</Typography>
                <Divider />
                {CompanyAlumniPara.map((data, index) => (
                  <Typography variant="body1" mt={2}>
                    {data.content}
                  </Typography>

                ))}


              </Paper>

            </ResponsiveBox>
          </Box>

          <Box data-aos="zoom-in" data-aos-duration="1000"
            sx={{
              position: 'relative',
            }}
          >
            <Paper elevation={3} sx={{ p: { xs: "0px", md: 3 }, mt: 2 }}>
              <Typography variant="h6" pl={{ xs: "15px" }} gutterBottom>Overview</Typography>
              <Table >
                <TableBody>
                  <TableRow>
                    <TableCell>Website</TableCell>
                    <TableCell>
                      <Link href="https://www.Cygnusa.ac.in" target="_blank" rel="noopener">www.Cygnusa.ac.in</Link>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>Industry</TableCell>
                    <TableCell>Textile</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>Company Size</TableCell>
                    <TableCell>38000+ alumni</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>Headquarters</TableCell>
                    <TableCell>New Delhi, India</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>Founded</TableCell>
                    <TableCell>1998</TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </Paper>
          </Box>

          <Box data-aos="zoom-in" data-aos-duration="1000"
            sx={{
              position: 'relative',
            }}
          >
            <Paper elevation={3} sx={{ p: 3, mt: 2 }}>
              <Typography variant="h6" gutterBottom>Locations</Typography>
              <Card>
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18..."
                  width="100%"
                  height="150"
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                  title="Cygnusa Location"
                ></iframe>
                <CardContent>
                  <Typography variant="body1">National Institute of Fashion Technology, Near Gulmohar Park, Hauz Khas, New Delhi, Pin Code-110016</Typography>
                  <Link
                    href="https://www.google.com/maps/dir/..."
                    target="_blank"
                    rel="noopener"
                  >
                    Get Directions
                  </Link>
                </CardContent>
              </Card>
            </Paper>
          </Box>
        </Container>
      </Box>
    </ProfileContainer>
  );
};

export default Home;
